<template>
  <v-app>
    <router-view />
    <Loader :active="loader" :size="50" :width="5" />
    <Message />
    <SliderDialog />
    <ResponseDialog />
    <DeleteDialog />
  </v-app>
</template>

<script lang="ts">
import Vue from "vue";
import Loader from "./components/Loader.vue";
import Message from "./components/Message.vue";
import SliderDialog from "./components/dialogs/SliderDialog.vue";
import ResponseDialog from "./components/dialogs/ResponseDialog.vue";
import DeleteDialog from "./components/dialogs/DeleteDialog.vue";

export default Vue.extend({
  name: "App",

  components: {
    Loader,
    Message,
    SliderDialog,
    ResponseDialog,
    DeleteDialog
},
  computed: {
    loader() {
      return this.$store.getters.getGlobalLoader;
    },
  },
});
</script>
<style>
@import "./assets/css/style.css";
</style>
